import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../environments/environment';
import { HeaderBasicAuthorizationService } from '../../../../../shared/services/header-basic-authorization.service';
import { ApiEnum } from '../../../../../shared/enums/api.enum';
@Injectable({
  providedIn: 'root'
})
export class CargoLaboralService {

    constructor(
        private http: HttpClient,
        private headerBasicAuthorization: HeaderBasicAuthorizationService
    ) {
    }
    
    public getTipoPagoList() {
        return this.http.get(`${environment.api.WS_HCM.url}/CargoLaboral/getTipoPagoList`,
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }

    public getCargoTrabajadorList() {
        return this.http.get(`${environment.api.WS_HCM.url}/CargoLaboral/getCargoTrabajadorList`,
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }
    public enableDisableCargoTrabajador(valor,future_status) {
        return this.http.post(`${environment.api.WS_HCM.url}/CargoLaboral/enableDisableCargoTrabajador`,{VALOR: valor, Future_Status: future_status},
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }
    public saveUpdateCargoTrabajador(model) {
        return this.http.post(`${environment.api.WS_HCM.url}/CargoLaboral/saveUpdateCargoTrabajador`,model,
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }

    public ListarArea() {
        return this.http.get(`${environment.api.WS_HCM.url}/CargoLaboral/ListarArea`,
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }

    public ListarGerencia() {
        return this.http.get(`${environment.api.WS_HCM.url}/CargoLaboral/ListarGerencia`,
        { headers: this.headerBasicAuthorization.get(ApiEnum.WS_HCM) })
        .pipe( map( data => data ));
    }
    
}
